export default __webpack_public_path__ + "static/media/ALPHA.16157f4d.png";